export default "__VITE_ASSET__14927c98__"